import React, { useState } from "react"

import { NotificationManager } from "react-notifications"
import { useHistory } from "react-router-dom"
import { gql, useMutation } from "urql"

import { ExclamationCircleIcon } from "@heroicons/react/24/outline"

import { Color, Size } from "~tailwindui/types/enums"

import { Button } from "~tailwindui/Basics"
import Modal from "~tailwindui/Modal"

import { RunMutation } from "src/types"

import { path } from "components/Tutor/TutorRoutes"

export type ConfirmSessionButtonProps = {
  id: string
  refetchQuery?: VoidFunction
  className?: string
}

const ConfirmSessionButton: React.FC<ConfirmSessionButtonProps> = ({
  id,
  refetchQuery,
  className = "",
}) => {
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState()

  const [mutationState, runMutation]: [any, RunMutation] = useMutation(
    confirmSessionMutation
  )

  const confirmSession = () => {
    runMutation({ id }).then(result => {
      const { failures, session } = result.data.confirmAirtutorsSession
      if (failures.length > 0) {
        setErrorMessage(failures[0].message)
        setOpen(true)
      } else {
        NotificationManager.success("The session has been confirmed")
        history.push(path("sessionDetails", { id: session.id }))
        if (refetchQuery) refetchQuery()
      }
    })
  }

  return (
    <>
      <Modal.Dialog hideButton isOpen={open} closeModal={() => setOpen(false)}>
        {closeModal => (
          <>
            <Modal.Header
              Icon={ExclamationCircleIcon}
              iconClassNames="text-red-500"
            >
              Confirmation Failed
            </Modal.Header>
            <Modal.Body>
              <p>{errorMessage}</p>
            </Modal.Body>
            <Modal.Footer>
              <div className="flex justify-end">
                <Button onClick={closeModal}>Okay</Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal.Dialog>

      <Button
        size={Size.Small}
        color={Color.Teal}
        className={className}
        onClick={confirmSession}
        disabled={mutationState.fetching}
      >
        Accept
      </Button>
    </>
  )
}

const confirmSessionMutation = gql`
  mutation confirmSession($id: ID!) {
    confirmAirtutorsSession(id: $id) {
      session {
        id
      }
      failures {
        message
      }
    }
  }
`

export default ConfirmSessionButton
